import { TableProps } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { TimesheetBaseTable } from 'components/organisms/timesheets/common/timesheet-table';
import { useWindowResize } from 'hooks/use-window-resize';
import { getTableHeight } from 'utils/auto-table-height';

export const BaseTable = styled(TimesheetBaseTable)`
  .ant-table-body {
    overflow: auto !important;
  }
`;
const Wrapper = styled.div``;

interface Props<T = any> extends TableProps<T> {
  className?: string;
}

export const Table: FC<Props> = ({ className, ...restProps }) => {
  const { height: tableBodyHeight } = useWindowResize(getTableHeight);

  return (
    <Wrapper className={className}>
      <BaseTable
        {...restProps}
        scroll={{
          y: `calc( ${tableBodyHeight}px - var(--spacing-05))`,
        }}
        pagination={false}
      />
    </Wrapper>
  );
};
